export default __webpack_public_path__ + "static/stanleyknifemark-d8f752edf9e9aad4568f69da90ae8fe7.png";